const options = [
  { to: '/', text: 'Home' },
  { to: '/portfolio/', text: 'Portfolio' },
  { to: '/skills/', text: 'Skills' },
  { to: '/contact/', text: 'Contact' },
];

export default options;
